import { Menu as MenuPrimitive } from '@base-ui/react/menu';

export type DropdownMenuProps = MenuPrimitive.Root.Props;

const DropdownMenu = ({ ...props }: DropdownMenuProps) => {
  return <MenuPrimitive.Root data-slot="dropdown-menu" {...props} />;
};

export default DropdownMenu;
